export const MAPCONTROL_NAME = "IntersectLayers";

export const DEFAULT_DRAWING_TOOLS = ["Point", "LineString", "Polygon", "Copy", "Modify"];